/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type RegisterAdminInput = {
    admin: AdminInput;
    recaptchaResponse?: string | null | undefined;
};
export type AdminInput = {
    acceptPrivacyPolicy: boolean;
    acceptTermsAndConditions: boolean;
    acceptedTermsAndConditionsId: string;
    credential: CredentialInput;
    name: string;
};
export type CredentialInput = {
    email: string;
    password: string;
};
export type Register_registerAdmin_MutationVariables = {
    input: RegisterAdminInput;
};
export type Register_registerAdmin_MutationResponse = {
    readonly registerAdmin: {
        readonly admin: {
            readonly name: string;
            readonly email: string;
        };
    } | null;
};
export type Register_registerAdmin_Mutation = {
    readonly response: Register_registerAdmin_MutationResponse;
    readonly variables: Register_registerAdmin_MutationVariables;
};



/*
mutation Register_registerAdmin_Mutation(
  $input: RegisterAdminInput!
) {
  registerAdmin(input: $input) {
    admin {
      name
      email
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Register_registerAdmin_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RegisterAdminPayload",
        "kind": "LinkedField",
        "name": "registerAdmin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Admin",
            "kind": "LinkedField",
            "name": "admin",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Register_registerAdmin_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RegisterAdminPayload",
        "kind": "LinkedField",
        "name": "registerAdmin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Admin",
            "kind": "LinkedField",
            "name": "admin",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ac6b8c95cea4dbb38576f465b033d803",
    "id": null,
    "metadata": {},
    "name": "Register_registerAdmin_Mutation",
    "operationKind": "mutation",
    "text": "mutation Register_registerAdmin_Mutation(\n  $input: RegisterAdminInput!\n) {\n  registerAdmin(input: $input) {\n    admin {\n      name\n      email\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '494940902a2c11e7aae6127e81e2b663';
export default node;
